import OsloAiPricing from './Oslo-AI-Pricing.json';
import v2_Oslo from './OsloAI230315.json';
import v2_Karlsruhe from "./KarlsruheAI250630.json"

export default {
  OsloAiPricing: OsloAiPricing,
  v2_Oslo,
  v2_Karlsruhe
};
